// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-404-js": () => import("./../src/templates/404.js" /* webpackChunkName: "component---src-templates-404-js" */),
  "component---src-templates-countries-js": () => import("./../src/templates/countries.js" /* webpackChunkName: "component---src-templates-countries-js" */),
  "component---src-templates-global-js": () => import("./../src/templates/global.js" /* webpackChunkName: "component---src-templates-global-js" */),
  "component---src-templates-home-js": () => import("./../src/templates/home.js" /* webpackChunkName: "component---src-templates-home-js" */)
}

